module.exports = __webpack_public_path__ + "img/special_effects.dc7979a6.png";